import { apiGet } from '../../api'

export const get_user_programs = query => {
  return apiGet({
    endpoint: `programs/get_user_programs?${query}`
  })
}
